import { isEqual } from 'lodash';
import { findOrInitializeById } from '../../utils/general';
import moment from 'moment';

export const convertIntervalToStatus = interval => {
  if (!interval) return {};
  const taskAvailabilityCodes = {};
  for (const [key, value] of Object.entries(interval.task_availability_codes)) {
    taskAvailabilityCodes[key] = value.availability_code_id;
  }

  return {
    availabilityRequirementLevel: interval.availability_requirement_level,
    taskAvailabilityCodes,
    warningLevel: interval.warning_level,
    serviceLevel: interval.service_level,
    skillStatuses: interval.skill_statuses
  };
};

export const nextStatusChange = (schedule, tasks, availabilityCodes, time) => {
  if (!schedule) return {};
  const intervals = schedule.intervals || [];
  const currentInterval = intervals.find(i =>
    moment(time).isBetween(moment(i.start_time), moment(i.end_time), null, '[)')
  );
  if (!currentInterval) return {};
  const currentStatus = convertIntervalToStatus(currentInterval);

  // find an interval that starts after the current, and has a different status
  const nextInterval = intervals.find(
    i =>
      moment(currentInterval.start_time).isBefore(i.start_time) && !isEqual(currentStatus, convertIntervalToStatus(i))
  );

  if (!nextInterval) return {};

  let nextStatus = convertIntervalToStatus(nextInterval);
  nextStatus = annotateTaskAvailabilityCodes(nextStatus, tasks, availabilityCodes);

  return { time: nextInterval.start_time, status: nextStatus };
};

export const annotateTaskAvailabilityCodes = (state, tasks, codes) => {
  if (!state) return;
  const { taskAvailabilityCodes } = state;
  const annotated = {};

  for (const [taskId, codeId] of Object.entries(taskAvailabilityCodes || {})) {
    annotated[taskId] = {
      task: findOrInitializeById(tasks, taskId),
      availabilityCode: findOrInitializeById(codes, codeId)
    };
  }
  return {
    ...state,
    taskAvailabilityCodes: annotated
  };
};
